module.exports = "/static/assets/7d6f0362fc2114f39b4f6651ebeda312.svg";